import React, {memo} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBoxHeart} from "@fortawesome/pro-light-svg-icons/faBoxHeart";
import {faClock} from "@fortawesome/pro-light-svg-icons/faClock";
import {faUserDoctor} from "@fortawesome/pro-light-svg-icons/faUserDoctor";

import styles from "./Insight.module.scss";

export default memo(function Insight({resultsInDays, showFreeDeliveryItem}) {
  return (
    <div
      className={`row gx-2 gx-md-3 justify-content-center justify-content-md-end align-items-center mx-auto ${styles.insight}`}>
      <div className="col-4 text-center">
        <FontAwesomeIcon icon={faUserDoctor} size="2x" className="fa-fw mb-2" />
        <p className="fw-normal mb-0">Expert results review & advice</p>
      </div>

      <div className="col-4 text-center text-pretty">
        <FontAwesomeIcon icon={faBoxHeart} size="2x" className="fa-fw mb-2" />
        <p className="fw-normal mb-0">Tracked 24 delivery & return</p>
      </div>

      <div className="col-4 text-center">
        <FontAwesomeIcon icon={faClock} size="2x" className="fa-fw mb-2" />
        <p className="fw-normal mb-0">Results in {resultsInDays} working days</p>
      </div>
    </div>
  );
});
